import { memo } from "react";
import { GRID_ACTIONS_COLUMN_TYPE, GridRowParams } from "@mui/x-data-grid";
import type { ResourceResponse } from "types";
import { TableGridMode } from "consts/table";
import { FilterVariant } from "consts/filters";
import { Filters, MenuItem } from "consts/openBanking";
import {
    selectOpenBankingResourceSlice,
    selectIsOpenBankingResourceLoading
} from "features/openBanking/selectors";
import { useIbanXSBanksRecipientsPivotActions } from "features/openBanking/actions";
import type { IbanXsBanksRecipientsPivot } from "features/openBanking/types";
import { useSimpleSwitch } from "ui/widgets/Table";
import useIbanXSBanksRecipientsPivot from "./useIbanXSBanksRecipientsPivot";
import IbanXSBanksRecipientsPivotDetail from "./IbanXSBanksRecipientsPivotDetail";
import IbanXSBanksRecipientsPivotToolbar from "./IbanXSBanksRecipientsPivotToolbar";
import { OpenBankingResource, EditOpenBankingResource } from "../shared";
import { DeleteIbanXSBanksRecipientsPivot } from "./actions";

const IbanXSBanksRecipientsPivot = () => {
    const {
        updateIbanXSBanksRecipientsPivot
    } = useIbanXSBanksRecipientsPivotActions();

    return (
        <OpenBankingResource
            BreadcrumbsProps={{
                heading: 'Iban XS Banks Recipients Pivot'
            }}
            ResourceProps={{
                name: 'Iban XS Banks Recipients Pivot',
                useResource: useIbanXSBanksRecipientsPivot,
                mode: TableGridMode.OpenBankingIbanXSBanksRecipientsPivot,
                selectIsTableUninitialized: () => true,
                // selectIsOpenBankingResourceUninitialized(MenuItem.IbanXSBanksRecipientsPivot),
                selectIsTableLoading: selectIsOpenBankingResourceLoading(MenuItem.IbanXSBanksRecipientsPivot),
                selectTableDataSlice: selectOpenBankingResourceSlice(MenuItem.IbanXSBanksRecipientsPivot),
                Toolbar: IbanXSBanksRecipientsPivotToolbar,
                Detail: IbanXSBanksRecipientsPivotDetail,
                CellProps: {
                    [Filters.isEnabled]: useSimpleSwitch({
                        handleChangeRequest: changePayload => {
                            const [request] = updateIbanXSBanksRecipientsPivot(changePayload);

                            return request as Promise<ResourceResponse<IbanXsBanksRecipientsPivot>>;
                        }
                    })
                },
                columns: [
                    {
                        field: GRID_ACTIONS_COLUMN_TYPE,
                        type: GRID_ACTIONS_COLUMN_TYPE,
                        getActions: (params: GridRowParams) => [
                            <EditOpenBankingResource
                                key='edit'
                                {...params}
                            />,
                            <DeleteIbanXSBanksRecipientsPivot
                                key='delete'
                                {...params}
                            />
                        ]
                    }
                ],
                filterTypes: new Map<FilterVariant, string[]>([
                    [FilterVariant.SingleOption, [Filters.isEnabled]]
                ])
            }}
        />
    );
};

export default memo(IbanXSBanksRecipientsPivot);
